import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
    title: ''
}

export const titleSlice = createSlice({
    name: 'title',
    initialState,
    reducers: {
        changeTitle: (state, action:  PayloadAction<string>) => ({
            ...state,
            title: action.payload
        })
    }
})
export const {changeTitle} = titleSlice.actions;
const {reducer: titleReducer } = titleSlice;
export default titleReducer;